import { Action } from "../../Actions/Action";
import * as React from "react";
import { IActionMenuParamsModel, IParameterModel, subAccountActionMenu } from "./IParameterModel";
import { SecuredCustomNavigationMenuOverlay } from "./SecuredCustomNavigationMenuOverlay";
import { NavigationSections } from "./Component/NavigationSections";
import { Contents, overlayLabels, productActionsLabels, subMenuLabels } from "../../Resoures/Contents";
import { SideMenu } from "../../../../Wrap/Constants/Enums/Menu/SideMenu";
import { SubaccountSideMenuMap } from "./Entities/SubaccountSideMenuMap";
import { ClientAccount } from "../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { isNullOrEmpty } from "../../../../react-core/Utils/Arrays";
import { PensionSubAccountSettings } from "../../../../Wrap/Models/Domains/SubAccount/PensionSubAccountSettings";
import { SubAccountType } from "../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { MenuItemsHelper } from "./Entities/MenuItemsHelper";
import { RestrictionAction } from "../Clients/Common/Restrictions/RestrictionAction";
import { ClientAccountStore, UserStore } from "../../Stroes/Variable";
import { checkPermission } from "../../../Shared/Permission/PermissionHelper";
import { UserClaim } from "../../../../Wrap/Constants/Enums/UserClaim";
import { InvestorType } from "../../../../Wrap/Models/Domains/Account/SlAccounts/InvestorType";
import { BaseComponent } from "../../../../react-core/Html/BaseComponent";
import { MenuItem } from "../../../../Wrap/Models/Domains/Menu/MenuItem";
import { ContextStore } from "../../../../react-core/Flux/Variables";
import { ContextType } from "../../../../Wrap/Constants/Enums/ContextType";
import { HierarchyIdHelper } from "../../../Shared/Common/HierarchyIdHelper";
import { AccountInfoAction } from "../Clients/PortfolioDashboard/Components/Role/Action/AccountInfoAction";
import { TrustDetail } from "../../../../Wrap/Models/Domains/Account/TrustDetail";
import { isConsolidate } from "../Clients/PortfolioDashboard/Components/Common/PortfolioDashboardHelper";
import { PortfolioViewMenuAdditionalInfoStore } from "./Store/Variable";
import { PortfolioViewActionMenuAdditionalInfoAction } from "./Action/PortfolioViewActionMenuAdditionalInfoAction";
import { CommonHelper } from "../../../../react-core/Helpers/CommonHelper";
import { ObjectComparer } from "../../../../react-core/Utils/ObjectComparer";
import { PortfolioViewMenuAdditionalInfo } from "../../../../Wrap/Models/Domains/Menu/PortfolioViewMenuAdditionalInfo";
import { PortfolioViewActionMenuOverlay } from "./Component/PortfolioViewActionMenuOverlay";
import { PortfolioRegularPayment } from "../../../../Wrap/Models/Domains/Valuation/PortfolioRegularPayment";
import { HierarchyLevelName } from "../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { ClientRecordAction } from "../Clients/ClientRecord/Action/ClientRecordAction";
import { ClientRecordStore } from "../Clients/ClientRecord/Store/Variable";
import { PersonalDetail } from "../../../../Wrap/Models/Models/Customer/PersonalDetail";
import { ClientRecordTab } from "../Clients/ClientRecord/Resource/Contents";
import { CustomerStatus } from "../../../../Wrap/Constants/Enums/Domain/CustomerStatus";
import { AccountStatus } from "../../../../Wrap/Models/Domains/Account/SlAccounts/AccountStatus";
import { ServiceProposition } from "../../../../Wrap/Constants/Enums/ServiceProposition";
import {
    ConsolidatedAccountStore,
    PortfolioDashboardStore,
    PortfolioDashboardAccountRolesStore,
} from "../Clients/PortfolioDashboard/Store/Variable";
import { AccountRole } from "../../../../Wrap/Models/Domains/Account/AccountRole";
import { IsaAllowance } from "../../../../Wrap/Models/Domains/IsaAllowance/IsaAllowance";
import { IsaAllowanceOverviewClient } from "../../../../Wrap/Api/ProductOverview/PaymentsIn/IsaAllowanceOverview";
import { JsonDateParser } from "../../../../react-core/Utils/JsonDateParser";
import { CompanyWizardAction } from "../../../Admin/Company/CompanyWizard/Actions/CompanyWizardAction";
import { FsaPermission } from "../../../../Wrap/Models/Models/Company/FsaPermission";
import { SubAccountTypeHelper } from "../Clients/Common/Helpers/SubAccountTypeHelper";
import { PortfolioDashboardAction } from "../Clients/PortfolioDashboard/Action/PortfolioDashboardAction";
import { AccountRoleWithAccountDetails } from "../../../../Wrap/Models/Domains/Customers/AccountRoleWithAccountDetails";
import { RoleType } from "../../../../Wrap/Constants/Enums/RoleType";
import { RoleStatus } from "../../../../Wrap/Constants/Enums/RoleStatus";
import { CustomerType } from "../../../../Wrap/Constants/Enums/Customer/CustomerType";
import { Organisation } from "../../../../Wrap/Models/Models/Customer/Organisation";
import { PensionArrangement } from "../../../../Wrap/Models/Models/Account/PensionArrangement";
import { User } from "../../../../Wrap/Models/Models/User/User";

interface ICustomNavigationMenuProps {
    onClick: (methodName: string) => void;
    urlParams: IActionMenuParamsModel;
}

interface ICustomNavigationMenuState {
    menu: MenuItem[];
    customNavigationVisibility: boolean;
    currentSideMenu: SideMenu;
    clientAccount: ClientAccount;
    pensionSubAccountSettings: PensionSubAccountSettings;
    pensionArrangements: Array<PensionArrangement>;
    urlParams: IActionMenuParamsModel;
    trustDetail: TrustDetail;
    additionalInfo: PortfolioViewMenuAdditionalInfo;
    productdetail: PortfolioRegularPayment;
    clientdetail: PersonalDetail;
    roles: AccountRole[];
    currentTaxYearISAAllowance: IsaAllowance;
    lastTaxYearISAAllowance: IsaAllowance;
    companyFsaPermission: FsaPermission[];
    actorUserID?: number;
    isLoading: boolean;
    accountRoleDetails: AccountRoleWithAccountDetails;
    customerType: CustomerType;
    userInfo: User;
}

export class CustomNavigationMenu extends BaseComponent<ICustomNavigationMenuProps, ICustomNavigationMenuState> {
    constructor(props: ICustomNavigationMenuProps) {
        super(props);
        this.state = {
            menu: [],
            customNavigationVisibility: true,
            currentSideMenu: props.urlParams.SideMenu,
            clientAccount: null,
            pensionSubAccountSettings: {},
            pensionArrangements:[],
            urlParams: props.urlParams,
            trustDetail: null,
            additionalInfo: null,
            productdetail: null,
            clientdetail: null,
            roles: [],
            currentTaxYearISAAllowance: null,
            lastTaxYearISAAllowance: null,
            companyFsaPermission: null,
            actorUserID: null,
            isLoading: false,
            accountRoleDetails: null,
            customerType: CustomerType.NotSpecified,
            userInfo: UserStore.getUserInfo()
        };
        this.subscribeToStore(ClientAccountStore, () => this.onClientAccountStoreChange());
        this.subscribeToStore(PortfolioViewMenuAdditionalInfoStore, () => this.onStoreChange());
        this.subscribeToStore(ClientRecordStore, () => {
            this.setState({ clientdetail: ClientRecordStore.getData()?.[ClientRecordTab.PersonalDetail] });
        });
    }

    shouldComponentUpdate(nextProps: ICustomNavigationMenuProps, nextState: ICustomNavigationMenuState) {
        if (nextState.customNavigationVisibility == false) {
            return true;
        }
        if (!ObjectComparer.isSame(nextState.productdetail, this.state.productdetail)) {
            return true;
        }
        if (!ObjectComparer.isSame(nextState.currentTaxYearISAAllowance, this.state.currentTaxYearISAAllowance)) {
            return true;
        }
        if (!ObjectComparer.isSame(nextState.lastTaxYearISAAllowance, this.state.lastTaxYearISAAllowance)) {
            return true;
        }
        if (!ObjectComparer.isSame(nextState.roles, this.state.roles)) {
            return true;
        }
        if (!ObjectComparer.isSame(nextState.trustDetail, this.state.trustDetail)) {
            return true;
        }
        if (!ObjectComparer.isSame(nextState.pensionSubAccountSettings, this.state.pensionSubAccountSettings)) {
            return true;
        }
        return ObjectComparer.arraysDiffer(this.state.menu, nextState.menu);
    }

    async onClientAccountStoreChange(): Promise<void> {
        const clientAccount = ClientAccountStore.getClientAccountInfo();
        const subAccount = (clientAccount?.SubAccounts || []).find(
            (ele) => ele.HierarchyId == this.state.urlParams.subaccountHierarchyId
        );
        const sideMenu = subAccount
            ? SubaccountSideMenuMap.getSubMenuBySubAccountType(subAccount.SubAccountType)
            : this.state.urlParams.SideMenu;

        this.setState(
            {
                clientAccount: clientAccount,
                currentSideMenu: sideMenu,
                urlParams: { headaccounthierarchyId: clientAccount?.HierarchyId, ...this.state.urlParams },
                isLoading: true,
            },
            async () => {
                this.getActionMenu(sideMenu);
                if (subAccount) {
                    if (this.state.pensionArrangements.length === 0 || Object.keys(this.state.pensionSubAccountSettings).length === 0) {
                        await this.getPensionData();
                    }
                    this.getIsaCashData();
                    PortfolioViewActionMenuAdditionalInfoAction.getRegularPayment(clientAccount.HierarchyId, (val) => {
                        this.setState({ productdetail: val });
                    });
                    if (SubAccountTypeHelper.isLegacyProduct(subAccount.SubAccountType)) {
                        CompanyWizardAction.getCompanyFsaPermissionDetail(clientAccount.Company, "AdviseInvestments", (data) => {
                            this.setState({ companyFsaPermission: data });
                        });
                    }
                }
                if (clientAccount.InvestorType == InvestorType.Trust) {
                    ClientRecordAction.getTrustDetails(clientAccount.HierarchyId, (result) => {
                        this.setState({ trustDetail: result, isLoading: false });
                    });
                } else {
                    this.setState({ isLoading: false });
                }
            }
        );
    }

    private getDataForPortfolioActionMenu(
        clientAccount: ClientAccount,
        sideMenu,
        levelHierarchyId,
        subAccountHierarchyId
    ) {
        this.setState(
            {
                clientAccount: clientAccount,
                currentSideMenu: sideMenu,
                urlParams: {
                    SideMenu: sideMenu,
                    subaccountHierarchyId: subAccountHierarchyId,
                    headaccounthierarchyId: clientAccount.HierarchyId,
                    levelHierarchyId: levelHierarchyId,
                },
            },
            async () => {
                this.getActionMenu(sideMenu);
                await this.getPensionData();
                if (clientAccount.InvestorType == InvestorType.Trust) {
                    ClientRecordAction.getTrustDetails(clientAccount.HierarchyId, (result) => {
                        this.setState({ trustDetail: result });
                    });
                }
                //consolidate underlying account
                if (isConsolidate() && sideMenu != SideMenu.ConsolidatedAccount) {
                    AccountInfoAction.getAccountRoles(clientAccount.HierarchyId, (roles) => {
                        this.setState({ roles: roles });
                    });
                }
            }
        );
    }

    onStoreChange(): void {
        const accountRoleDetails = PortfolioDashboardAccountRolesStore.getData();
        this.setState({ accountRoleDetails: accountRoleDetails });
        const { urlParams } = this.state;
        const additionalInfo = PortfolioViewMenuAdditionalInfoStore.getData();
        this.setState({ additionalInfo: additionalInfo });
        if (
            urlParams.SideMenu == SideMenu.ConsolidatedAccount &&
            urlParams.headaccounthierarchyId == ConsolidatedAccountStore.getData()?.HierarchyId
        ) {
            this.getDataForPortfolioActionMenu(
                ConsolidatedAccountStore.getData(),
                SideMenu.ConsolidatedAccount,
                urlParams.headaccounthierarchyId,
                null
            );
        } else if (additionalInfo?.UnderlyingClientAccount?.length === 0) {
            //prospect customer
            this.getActionMenu(SideMenu.Account);
        } else if (additionalInfo?.UnderlyingClientAccount?.length === 1) {
            // only one account
            this.getDataForPortfolioActionMenu(
                additionalInfo?.UnderlyingClientAccount?.[0],
                SideMenu.Portfolio,
                urlParams.levelHierarchyId,
                null
            );
        } else {
            this.getDataForPortfolioActionMenu(
                additionalInfo?.UnderlyingClientAccount?.find(
                    (ele) => ele.HierarchyId == urlParams.headaccounthierarchyId
                ) || additionalInfo?.UnderlyingClientAccount?.[0],
                SideMenu.Portfolio,
                urlParams.headaccounthierarchyId || additionalInfo?.UnderlyingClientAccount?.[0].HierarchyId,
                null
            );
        }
    }

    private noPendingDataActionMenu = (): SideMenu[] => {
        return [SideMenu.BusinessManagement, SideMenu.Admin, SideMenu.ToolLiterature, SideMenu.Dashboard];
    };

    private getDataForSideMenu(
        sideMenu: SideMenu,
        levelhierarchyId: string,
        headAccountHierarchyId: string,
        subAccountHierarchyId: string
    ) {
        this.setState(
            {
                urlParams: {
                    SideMenu: sideMenu,
                    subaccountHierarchyId: subAccountHierarchyId,
                    headaccounthierarchyId: headAccountHierarchyId,
                    levelHierarchyId: levelhierarchyId,
                },
            },
            () => {
                if (
                    HierarchyIdHelper.generateHierarchyId(levelhierarchyId)?.hierarchyLevel ==
                        HierarchyLevelName.Customer &&
                    this.state.clientdetail == null
                ) {
                    ClientRecordAction.getPersonalDetail(this.getCustomerId().toString());
                }
                if (this.noPendingDataActionMenu().includes(sideMenu)) {
                    this.setState({ currentSideMenu: sideMenu }, () => this.getActionMenu(sideMenu));
                } else if (
                    [SideMenu.NotSpecified, SideMenu.Portfolio].includes(sideMenu) ||
                    subAccountActionMenu.includes(sideMenu)
                ) {
                    // If navigate to old aspx page we won't get hierarchyId
                    if (headAccountHierarchyId || subAccountHierarchyId) {
                        Action.getClientAccount(headAccountHierarchyId || subAccountHierarchyId);
                        RestrictionAction.getRestrictionByHierarchyId(headAccountHierarchyId || subAccountHierarchyId);
                    }
                } else if (sideMenu === SideMenu.Account || sideMenu == SideMenu.ConsolidatedAccount) {
                    PortfolioViewActionMenuAdditionalInfoAction.get(levelhierarchyId);
                }
            }
        );
    }

    public componentDidMount() {
        const { urlParams } = this.props;
        const customerId = this.getCustomerId();
        if (isConsolidate()) {
            urlParams.SideMenu = SideMenu.ConsolidatedAccount;
            urlParams.headaccounthierarchyId = ConsolidatedAccountStore.getData()?.HierarchyId;
        }
        this.getDataForSideMenu(
            urlParams.SideMenu,
            urlParams.levelHierarchyId,
            urlParams.headaccounthierarchyId,
            urlParams.subaccountHierarchyId
        );
        if (this.getCustomerId() && !isConsolidate()) {
            PortfolioDashboardAction.getAccountRoleWithAccountDetails(this.getCustomerId(), (data) => {
                this.setState({ actorUserID: data.ActorUserId });
            });
        }
        const clientDetailData = ClientRecordStore.getData();
        if (clientDetailData && !CommonHelper.isNullOrEmpty(clientDetailData[ClientRecordTab.PersonalDetail])) {
            this.setState({
                customerType: CustomerType.Individual,
            });
        }
        if (clientDetailData && !CommonHelper.isNullOrEmpty(clientDetailData[ClientRecordTab.OrganisationDetails])) {
            const organisation: Organisation = clientDetailData[ClientRecordTab.OrganisationDetails];
            if (organisation?.CustomerType && organisation?.CustomerType !== CustomerType.Company) {
                this.setState({
                    customerType: organisation.CustomerType,
                });
            } else {
                if (!CommonHelper.isNullOrEmpty(clientDetailData[ClientRecordTab.CompanyDetails])) {
                    this.setState({
                        customerType: CustomerType.Company,
                    });
                }
            }
        }
    }

    private getHeader = (): { mainHeader: string; subHeader: string } => {
        const { currentSideMenu, urlParams, clientAccount, additionalInfo } = this.state;
        if (
            (currentSideMenu == SideMenu.Account && this.getCustomerId()) ||
            currentSideMenu == SideMenu.Portfolio ||
            currentSideMenu == SideMenu.ConsolidatedAccount
        ) {
            return {
                mainHeader: `${additionalInfo == null || additionalInfo == undefined ? `` : additionalInfo.Name}`,
                subHeader: `${
                    currentSideMenu == SideMenu.ConsolidatedAccount ? "ACCOUNT ID" : "CLIENT ID"
                }: ${this.getCustomerId()}`,
            };
        }
        if (subAccountActionMenu.includes(currentSideMenu)) {
            const subAccount = (clientAccount?.SubAccounts || []).find(
                (ele) => ele.HierarchyId == urlParams.subaccountHierarchyId
            );
            return {
                mainHeader: `${subAccount?.ProductDisplayName}`,
                subHeader: subAccount?.ClAccountId,
            };
        }
        return null;
    };

    private canCreateOrEditUser() {
        //conditions to hide create user :
        //1. hold ShareholderGT25 only
        //2. hold LetterOfAuthority only
        //3. hold both LetterOfAuthority and ShareholderGT25 only
        //4. hold no roles
        //5. organisation but not corporate trustee
        //TODO : some condition above may not valid need to check with Dan
        const { accountRoleDetails } = this.state;
        const _accountroles = accountRoleDetails?.AccountRoles || [];
        const shareholderGT25Len = _accountroles.filter((ele) => ele.AccountRoleType == RoleType.ShareholderGT25)
            .length;
        const letterOfAuthLen = _accountroles.filter((ele) => ele.AccountRoleType == RoleType.ShareholderGT25).length;
        const invalidLen = shareholderGT25Len + letterOfAuthLen;
        if (
            _accountroles.some(
                (ele) => ele.AccountRoleType == RoleType.Trustee && ele.AccountRoleStatus == RoleStatus.Active
            ) &&
            this.state.customerType != CustomerType.Individual
        ) {
            return true;
        }
        if (
            invalidLen == _accountroles.length ||
            (accountRoleDetails?.AccountRoles || []).filter(
                (role) =>
                    role.AccountStatus.toLowerCase() != "inprogress" && role.AccountRoleStatus != RoleStatus.Inactive
            ).length == 0 ||
            this.state.customerType != CustomerType.Individual
        ) {
            return false;
        } else {
            return true;
        }
    }

    public render(): JSX.Element {
        const menu = this.getMenu();
        const additionalInfo = this.state.additionalInfo;
        return (
            <>
                <SecuredCustomNavigationMenuOverlay
                    mainHeader={this.getHeader()?.mainHeader}
                    isFz={this.state.clientAccount?.AccountServicePropositionId == ServiceProposition.Fundzone}
                    onClick={(method: string) => this.onClick(method)}
                    customNavigationVisibility={this.state.customNavigationVisibility}
                    subHeader={this.getHeader()?.subHeader}
                    onBackClick={() => {
                        const type = HierarchyIdHelper.generateHierarchyId(this.props.urlParams?.levelHierarchyId)
                            .hierarchyLevel;
                        if (type == HierarchyLevelName.Customer) {
                            //if previous level is portfolio level, then get sidemenu by customer hierarchyId
                            this.getDataForSideMenu(
                                SideMenu.Account,
                                this.props.urlParams.levelHierarchyId,
                                null,
                                null
                            );
                        } else {
                            this.getDataForSideMenu(
                                SideMenu.Account,
                                this.props.urlParams.levelHierarchyId,
                                this.state.clientAccount.HierarchyId,
                                null
                            );
                        }
                    }}
                    showBack={this.shouldShowBackOption()}
                >
                    <>
                        {[SideMenu.Portfolio, SideMenu.ConsolidatedAccount].includes(this.state.urlParams.SideMenu) &&
                            additionalInfo?.UnderlyingClientAccount?.length > 1 && (
                                <PortfolioViewActionMenuOverlay
                                    additionalInfo={additionalInfo}
                                    onChangeHeadAccount={(hierarchyId) => {
                                        const isCon = hierarchyId == ConsolidatedAccountStore.getData()?.HierarchyId;
                                        this.getDataForPortfolioActionMenu(
                                            additionalInfo?.UnderlyingClientAccount?.find(
                                                (ele) => ele.HierarchyId == hierarchyId
                                            ),
                                            isCon ? SideMenu.ConsolidatedAccount : SideMenu.Portfolio,
                                            this.state.urlParams.levelHierarchyId,
                                            null
                                        );
                                    }}
                                    selectedHeadAccount={this.state.urlParams.headaccounthierarchyId}
                                />
                            )}
                        {!this.state.isLoading && (
                            <NavigationSections
                                headClAccountId={this.state?.clientAccount?.HeadClAccountId}
                                accountStatus={this.state?.clientAccount?.AccountStatus ?? AccountStatus.InActive}
                                urlParams={this.state.urlParams}
                                navigationConfig={menu}
                                companyFsaPermission={this.state.companyFsaPermission}
                                heading={
                                    !CommonHelper.isNullOrEmpty(this.state.urlParams.levelHierarchyId)
                                        ? null
                                        : overlayLabels[this.state.currentSideMenu]
                                }
                                productdetail={this.state.productdetail}
                                onHierarchyIdClick={(sideMenu: SideMenu, hierarchyId: string) => {
                                    this.getDataForSideMenu(
                                        sideMenu,
                                        this.state.urlParams.levelHierarchyId,
                                        sideMenu === SideMenu.Portfolio
                                            ? hierarchyId
                                            : this.state.urlParams.headaccounthierarchyId,
                                        sideMenu === SideMenu.Portfolio ? null : hierarchyId
                                    );
                                }}
                                trustDetail={this.state.trustDetail}
                                sideMenu={this.state.currentSideMenu}
                            />
                        )}
                    </>
                </SecuredCustomNavigationMenuOverlay>
            </>
        );
    }

    private async getPensionData(): Promise<void> {
        const nprSubAccount = (this.state.clientAccount?.SubAccounts || []).find(
            (subAccount) => subAccount.SubAccountType === SubAccountType.Npr || subAccount.SubAccountType === SubAccountType.JuniorSipp
        );
        if (nprSubAccount) {
            const pensionArrangementDetailsPromise = Action.getPensionArrangementDetails(nprSubAccount.HierarchyId, false)
                .then((val) => {
                    this.setState({
                        pensionArrangements: val,
                    });
                });
    
            const pensionSubAccountSettingPromise = Action.getPensionSubAccountSettings(nprSubAccount.HierarchyId, true)
                .then((val) => {
                    this.setState({
                        pensionSubAccountSettings: val,
                    });
                });
    
            await Promise.all([pensionArrangementDetailsPromise, pensionSubAccountSettingPromise]);
        }
    }

    private getIsaCashData(): void {
        const isaCash = (this.state.clientAccount?.SubAccounts || []).find(
            (subAccount) => subAccount.SubAccountType === SubAccountType.CashIsa
        );
        if (isaCash) {
            new IsaAllowanceOverviewClient().get(this.state.clientAccount.HierarchyId, 1).onSuccess((x) => {
                this.setState({ lastTaxYearISAAllowance: x });
            });
            new IsaAllowanceOverviewClient().get(this.state.clientAccount.HierarchyId, 0).onSuccess((x) => {
                this.setState({ currentTaxYearISAAllowance: x });
            });
        }
    }

    private getCustomerId(): number {
        const hierarchyId = ContextStore.getUrlParamsHierarchyId(ContextType.Customer);
        if (!hierarchyId) {
            return HierarchyIdHelper.generateHierarchyId(this.state.urlParams.levelHierarchyId).entityId;
        }
        return HierarchyIdHelper.generateHierarchyId(hierarchyId).entityId;
    }

    private getActionMenu(sideMenu: SideMenu): void {
        const { clientAccount } = this.state;
        Action.getActionMenus(
            sideMenu,
            clientAccount?.HierarchyId,
            (clientAccount?.SubAccounts || []).find(
                (ele) => ele.HierarchyId == this.state.urlParams.subaccountHierarchyId
            )?.HierarchyId,
            clientAccount?.HeadClAccountId,
            this.getCustomerId(),
            (val) => {
                const menu = val.concat();

                this.setState({
                    menu: menu,
                    currentSideMenu: sideMenu,
                });
            }
        );
    }

    private shouldShowBackOption(): boolean {
        return subAccountActionMenu.some((menu) => menu === this.state.currentSideMenu);
    }

    private onClick(method: string) {
        this.setState({ customNavigationVisibility: method !== Contents.Method_CloseMenu }, () => {
            this.props.onClick(method);
        });
    }

    private getMenu(): MenuItem[] {
        let menu = this.state.menu.concat();
        const { currentSideMenu } = this.state;
        const { accountRoleDetails } = this.state;
        /**
         * onshore bond and offshore bond, data backfill
         */
        if (currentSideMenu == SideMenu.OnshoreBond || currentSideMenu == SideMenu.OffshoreBond) {
            let subaccount = null;
            if (currentSideMenu == SideMenu.OnshoreBond) {
                subaccount = (this.state.clientAccount?.SubAccounts || []).find(
                    (x) =>
                        x.SubAccountType == SubAccountType.OnshoreBond &&
                        x.HierarchyId == this.state.urlParams.subaccountHierarchyId
                );
            }
            if (currentSideMenu == SideMenu.OffshoreBond) {
                subaccount = (this.state.clientAccount?.SubAccounts || []).find(
                    (x) =>
                        x.SubAccountType == SubAccountType.OffshoreBond &&
                        x.HierarchyId == this.state.urlParams.subaccountHierarchyId
                );
            }
            if (checkPermission(UserClaim.AdviserPortalAccountInfoCanView)) {
                const data: MenuItem = {
                    MenuCaption: "Bond options",
                    SubMenu: [
                        {
                            MenuCaption: "Account info",
                            Url: `/clients/clientdetails/clientdetails-accountinfo.aspx?claccountid=${subaccount?.ClAccountId}&subaccounttype=${subaccount?.SubAccountType}`,
                        },
                    ],
                };
                menu.push(data);
            }
        }
        let quickDeposit = menu.find((ele) => ele.MenuCaption.toLowerCase() == "Payments".toLowerCase())?.SubMenu;
        if (quickDeposit) {
            quickDeposit = quickDeposit.filter((a) => a.MenuCaption.toLowerCase() != "Quick deposit".toLowerCase());
            menu.find((ele) => ele.MenuCaption.toLowerCase() == "Payments".toLowerCase()).SubMenu = quickDeposit;
        }
        if (currentSideMenu == SideMenu.Account && !isConsolidate()) {
            let sub = menu.find((ele) => ele.MenuCaption.toLowerCase() == "Client Details".toLowerCase())?.SubMenu;
            if (sub) {
                sub = checkPermission(UserClaim.AdviserPortalCustomerPartialAccessCanView)
                    ? [
                          {
                              HierarchyId: null,
                              MenuCaption: "Personal details",
                              Url: `/wpadviser/en-gb/dashboard/home/main/customer/${this.props.urlParams.levelHierarchyId}/detail`,
                          },
                          {
                              MenuCaption: "Interested Parties",
                              Url: `/wpadviser/en-gb/dashboard/home/main/customer/${this.props.urlParams.levelHierarchyId}/roles`,
                          },
                      ]
                    : [];
                menu.find((ele) => ele.MenuCaption.toLowerCase() == "Client Details".toLowerCase()).SubMenu = sub;
            }
        }
        if (currentSideMenu == SideMenu.Portfolio) {
            let sub = menu.find((ele) => ele.MenuCaption.toLowerCase() == "Client details".toLowerCase())?.SubMenu;
            if (sub) {
                let updatedSub = sub.map((item) => {
                    if (item.MenuCaption.toLowerCase() == "Personal details".toLowerCase()) {
                        return {
                            ...item,
                            Url: isConsolidate()
                                ? `/wpadviser/en-gb/dashboard/home/main/customer/${
                                      this.state.roles.find((ele) => ele.IsPrimary)?.Customer?.HierarchyId
                                  }/detail`
                                : `/wpadviser/en-gb/dashboard/home/main/customer/${this.props.urlParams.levelHierarchyId}/detail`,
                        };
                    }
                    if (item.MenuCaption.toLowerCase() == "Account details".toLowerCase()) {
                        return {
                            ...item,
                            Url:
                                this.state.clientAccount?.InvestorType == InvestorType.Trust
                                    ? `/clients/clientdetails/clientdetails-accountinfo.aspx?claccountid=${this.state.clientAccount?.HeadClAccountId}`
                                    : `/wpadviser/en-gb/dashboard/home/main/customer/${
                                          isConsolidate()
                                              ? this.state.roles.find((ele) => ele.IsPrimary)?.Customer?.HierarchyId
                                              : this.props.urlParams.levelHierarchyId
                                      }/roles?showaccountinfo=${this.state.clientAccount?.HierarchyId}`,
                        };
                    }
                    return item;
                });
                if (!checkPermission(UserClaim.AdviserPortalCustomerPartialAccessCanView)) {
                    updatedSub = updatedSub.filter(
                        (x) => x.MenuCaption.toLowerCase() != "Personal details".toLowerCase()
                    );
                }
                if (
                    !checkPermission(UserClaim.AdviserPortalAccountInfoCanView) &&
                    this.state.clientAccount?.InvestorType == InvestorType.Trust
                ) {
                    updatedSub = updatedSub.filter(
                        (x) => x.MenuCaption.toLowerCase() != "Account details".toLowerCase()
                    );
                }
                if (
                    !checkPermission(UserClaim.AdviserPortalCustomerPartialAccessCanView) &&
                    this.state.clientAccount?.InvestorType != InvestorType.Trust
                ) {
                    updatedSub = updatedSub.filter(
                        (x) => x.MenuCaption.toLowerCase() != "Account details".toLowerCase()
                    );
                }
                menu.find(
                    (ele) => ele.MenuCaption.toLowerCase() == "Client details".toLowerCase()
                ).SubMenu = updatedSub;
            }
            //modify the menu button according to different condition
            if (
                this.canCreateOrEditUser() &&
                ((checkPermission(UserClaim.AdviserPortalDluEditUserCanView) && accountRoleDetails?.ActorUserId > 0) ||
                    ((accountRoleDetails?.ActorUserId == 0 || accountRoleDetails?.ActorUserId == undefined) &&
                        checkPermission(UserClaim.AdviserPortalDluNewUserCanView)))
            ) {
                const sub =
                    this.state.actorUserID > 0
                        ? [
                              {
                                  MenuCaption: "Edit User",
                                  Url: `/admin/users/edituser.aspx?searchuserid=${this.state.actorUserID}&type=EDIT`,
                              },
                          ]
                        : [
                              {
                                  MenuCaption: "Create User",
                                  Url: `/admin/users/newuser.aspx?customerid=${this.getCustomerId()}`,
                              },
                          ];

                const userAccessMenu = menu.find(
                    (ele) => ele.MenuCaption.toLowerCase() === "User Access".toLowerCase()
                );
                if (userAccessMenu) {
                    userAccessMenu.SubMenu = sub;
                }
            } else {
                menu = menu.filter((ele) => ele.MenuCaption.toLowerCase() !== "User Access".toLowerCase());
            }
        }
        if (currentSideMenu == SideMenu.ConsolidatedAccount) {
            let sub = menu.find((ele) => ele.MenuCaption.toLowerCase() == "Client Details".toLowerCase())?.SubMenu;
            if (sub) {
                let updatedSub = sub.map((item) => {
                    if (item.MenuCaption.toLowerCase() == "Account details".toLowerCase()) {
                        return {
                            ...item,
                            Url: `/clients/clientdetails/clientdetails-accountinfo.aspx?claccountid=${
                                ConsolidatedAccountStore.getData()?.HeadClAccountId
                            }`,
                        };
                    }
                    return item;
                });

                if (!checkPermission(UserClaim.AdviserPortalAccountInfoCanView)) {
                    updatedSub = updatedSub.filter(
                        (x) => x.MenuCaption.toLowerCase() != "Account details".toLowerCase()
                    );
                }
                menu.find(
                    (ele) => ele.MenuCaption.toLowerCase() == "Client Details".toLowerCase()
                ).SubMenu = updatedSub;
            }
        }
        /**
         * head account level, data backfill
         */
        if (this.state.currentSideMenu == SideMenu.Portfolio) {
            const subMenus: MenuItem[] = (this.state.clientAccount?.SubAccounts || []).map((subaccount) => {
                let menuCaption = subaccount.ProductDisplayName;
                if (subaccount.ProductDisplayName.toLowerCase() == "Personal Portfolio".toLowerCase()) {
                    menuCaption = subaccount.ProductDisplayName + "-" + subaccount.ClAccountId.slice(-3);
                }
                return { MenuCaption: menuCaption, HierarchyId: subaccount.HierarchyId };
            });
            const hierarchyid = this.state.clientAccount?.HierarchyId;
            const customerid = this.getCustomerId();
            if (this.state.clientdetail?.CustomerStatus != CustomerStatus.Deceased) {
                if (
                    this.state.clientAccount?.InvestorType == InvestorType.Trust &&
                    checkPermission(UserClaim.AdviserPortalNewQuoteNewBusinessReadWrite)
                ) {
                    
                    const headClaccountId = this.state.clientAccount?.HeadClAccountId;
                    subMenus.push({
                        MenuCaption: subMenuLabels.newProductLabel,
                        Url:
                            "/clients/newbusiness/newtransfer.aspx?filter=newbusinessexistingclient&needclient=1&claccountid=" +
                            headClaccountId,
                    });
                } else if (
                    this.state.clientAccount?.InvestorType != InvestorType.Trust &&
                    checkPermission(UserClaim.AdviserPortalNewQuoteNewBusinessReadWrite) && 
                    !(
                        this.state.pensionSubAccountSettings?.HasDisqualifyingPensionCredit &&
                        this.state.userInfo?.IsAdviser &&
                        this.state.clientAccount?.SubAccounts?.some((account) => account.SubAccountType == SubAccountType.Npr)
                    )
                ) {
                    subMenus.push({
                        MenuCaption: subMenuLabels.newProductLabel,
                        Url: `/wpadviser/en-gb/dashboard/home/main/client/new-business/full-client-detail?customerid=${customerid}&hierarchyid=${hierarchyid}`,
                    });
                }
                if (
                    this.state.clientAccount?.InvestorType != InvestorType.Trust &&
                    checkPermission(UserClaim.AdviserPortalPortfolioViewAddNewAccountReadWrite) &&
                    !PortfolioDashboardStore.hasInProgressAccounts()
                ) {
                    subMenus.push({
                        MenuCaption: subMenuLabels.createNB,
                        Url: `/wpadviser/en-gb/dashboard/home/main/client/new-business/full-client-detail?customerid=${customerid}`,
                    });
                }
            }

            const productActions: MenuItem[] = [
                {
                    MenuCaption: productActionsLabels.heading,
                    SubMenu: subMenus,
                },
            ];
            if (
                [
                    InvestorType.Individual,
                    InvestorType.Joint,
                    InvestorType.Trust,
                    InvestorType.JointIndividual,
                ].includes(this.state.clientAccount?.InvestorType)
            ) {
                // todo confirm with Dan
                const clientDetailsMenuItem = menu.find((ele) => ele.MenuCaption.toLowerCase() === "client details".toLowerCase());

                if (clientDetailsMenuItem) {
                    
                    let sub = clientDetailsMenuItem.SubMenu.filter((x) => x.MenuCaption.toLowerCase() !== "capital gains settings".toLowerCase());

                    if (!Array.isArray(sub)) {
                        sub = [];
                    }

                    sub.push({
                        MenuCaption: "Capital Gains Settings",
                        Url: `/wpadviser/en-gb/dashboard/home/main/client/cgt/cgt?clienthierarchyid=${
                            isConsolidate()
                                ? this.state.roles.find((ele) => ele.IsPrimary)?.Customer?.HierarchyId
                                : this.props.urlParams.levelHierarchyId
                        }&hierarchyid=${hierarchyid}&customerid=${
                            isConsolidate()
                                ? this.state.roles.find((ele) => ele.IsPrimary)?.Customer?.CustomerId
                                : customerid
                        }`,
                    });

                    clientDetailsMenuItem.SubMenu = sub;
                } else {
                    console.warn("Menu item 'Client details' not found.");
                }
            }
            if (
                checkPermission(UserClaim.AdviserPortalCustomerPartialAccessCanView) &&
                menu.find((ele) => ele.MenuCaption.toLowerCase() == "Client details".toLowerCase()) != undefined
            ) {
                let sub: MenuItem[] = menu
                    .find((ele) => ele.MenuCaption.toLowerCase() == "Client details".toLowerCase())
                    ?.SubMenu.filter((x) => x.MenuCaption != "Interested Parties");
                sub.push({
                    MenuCaption: "Interested Parties",
                    Url: `/wpadviser/en-gb/dashboard/home/main/customer/${
                        isConsolidate()
                            ? this.state.roles.find((ele) => ele.IsPrimary)?.Customer?.HierarchyId
                            : this.props.urlParams.levelHierarchyId
                    }/roles`,
                });
                menu.find((ele) => ele.MenuCaption.toLowerCase() == "Client details".toLowerCase()).SubMenu = sub;
            }
            menu = productActions.concat(menu);
        }
        /**
         * NPR, data backfill
         */
        if (
            this.state.currentSideMenu === SideMenu.NewSipp &&
            Object.keys(this.state.pensionSubAccountSettings).length > 0
        ) {
            const nprSubAccount = this.state.clientAccount?.SubAccounts.filter(
                (subAccount) =>
                    (subAccount.SubAccountType === SubAccountType.Npr || subAccount.SubAccountType === SubAccountType.JuniorSipp) &&
                    subAccount.HierarchyId == this.state.urlParams.subaccountHierarchyId
            )[0];

            const queryParameter: IParameterModel = {
                SideMenu: currentSideMenu,
                clAccountId: this.state.clientAccount?.HeadClAccountId,
                hierarchyId: this.state.clientAccount?.HierarchyId,
                customerId: this.getCustomerId(),
            };
            const conditionalSubMenus: MenuItem[] = MenuItemsHelper.getConditionalMenuItems(
                this.state.pensionSubAccountSettings,
                this.state.pensionArrangements,
                queryParameter,
                nprSubAccount
            );
            //todo add permission check when we build pension
            if (!isNullOrEmpty(menu)) { 
                menu.forEach((item) => {
                    if (item.MenuCaption === "Drawdown") {
                        if (!this.state.pensionSubAccountSettings?.CanEditRegularCrystallisation) {
                            item.SubMenu = item.SubMenu.filter(
                                (subMenu) => subMenu.MenuCaption.toLowerCase() !== "edit income drawdown"
                            );
                        }
                        if (!this.state.pensionSubAccountSettings?.GadReviewEnabled) {
                            item.SubMenu = item.SubMenu.filter(
                                (subMenu) => subMenu.MenuCaption.toLowerCase() !== "gad review"
                            );
                        }
                        if (
                            this.state.pensionSubAccountSettings?.HasDisqualifyingPensionCredit &&
                            this.state.userInfo?.IsAdviser
                        ) {
                            item.SubMenu = item.SubMenu.filter(
                                (subMenu) => subMenu.MenuCaption.toLowerCase() !== "take pension benefits"
                            );
                        }
                        //pupulate url depending on menu caption
                        item.SubMenu?.forEach((subMenu, index, object) => {
                            if (subMenu.MenuCaption.toLowerCase() == "gad review") {
                                let mappedGadReviewSubMenus = conditionalSubMenus.filter((x) =>
                                    x.MenuCaption.toLowerCase().includes("gad review")
                                );
                                if (!mappedGadReviewSubMenus) {
                                    subMenu.Url = "";
                                }
                                else if (mappedGadReviewSubMenus.length > 0) {
                                    subMenu.SubMenu = mappedGadReviewSubMenus;
                                }
                                else {
                                    subMenu.Url = "";
                                }
                            } else {
                                let mappedSubMenu = conditionalSubMenus.filter(
                                    (x) => x.MenuCaption.toLowerCase() == subMenu.MenuCaption.toLowerCase()
                                )?.[0];
                                if (!mappedSubMenu) {
                                    subMenu.Url = "";
                                }
                                else if (mappedSubMenu.Url != "") {
                                    subMenu.Url = mappedSubMenu.Url;
                                }
                            }
                        });

                        item.SubMenu = item.SubMenu.filter(
                            (subMenu) => subMenu.Url.length > 0 || subMenu.SubMenu.length > 0
                        );
                    }
                    else if (item.MenuCaption === "Money out") {
                        item.SubMenu?.forEach((subMenu) => {
                            if (subMenu.MenuCaption.toLowerCase() == "pp to s&s isa") {
                                const mappedSubMenu = conditionalSubMenus.filter(
                                    (x) => x.MenuCaption.toLowerCase() == subMenu.MenuCaption.toLowerCase()
                                )?.[0];
                                if (!mappedSubMenu) {
                                    subMenu.Url = "";
                                }
                            }
                        });

                        item.SubMenu = item.SubMenu.filter(
                            (subMenu) => subMenu.Url.length > 0 || subMenu.SubMenu.length > 0
                        );
                    }
                });

                menu = menu.filter((menu) => menu.SubMenu.length > 0);
            }
        }
        /**
         * sub account data backfill
         */
        if (this.state.currentSideMenu == SideMenu.IsaCash) {
            if (!this.state.currentTaxYearISAAllowance || !this.state.lastTaxYearISAAllowance) {
                menu = [];
            } else {
                const index = menu.findIndex((x) => x.MenuCaption.toLowerCase() == "Payments".toLowerCase());
                const canDoContribution =
                    (this.state.currentTaxYearISAAllowance?.Expected.Amount > 0 ||
                        this.state.currentTaxYearISAAllowance?.Used.Amount > 0 ||
                        this.state.lastTaxYearISAAllowance?.Expected.Amount > 0 ||
                        this.state.lastTaxYearISAAllowance?.Used.Amount > 0) &&
                    JsonDateParser.toDate(this.state.currentTaxYearISAAllowance?.StopIsaCashDate) >= new Date();
                if (!canDoContribution) {
                    menu.splice(index, 1);
                }
            }
        }
        const currentState = this.state;

        if (currentState.currentSideMenu == SideMenu.PersonalPortfolio || currentState.currentSideMenu == SideMenu.IsaStocks || currentState.currentSideMenu == SideMenu.NewSipp) {
            const index = menu.findIndex((x) => x.MenuCaption.toLowerCase() == "Projections".toLowerCase());

            if (index > -1) {
                const indexWhatIf = menu[index].SubMenu.findIndex(
                     (x) => x.MenuCaption.toLowerCase() == "Launch 'What if' tool".toLowerCase()
                );
                if (indexWhatIf > -1) {
                    const currentSubAccount = (currentState.clientAccount?.SubAccounts || []).find(
                        (ele) => ele.HierarchyId == currentState.urlParams.subaccountHierarchyId
                    );
                  if (currentState.clientAccount?.InvestorType == InvestorType.Trust ||(currentSubAccount && currentSubAccount.SubAccountType == SubAccountType.JuniorSipp)) {
                        menu[index].SubMenu.splice(indexWhatIf, 1);

                    }

                }

            }

        }

        return menu;
    }
}
